import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  fetchTestAccept,
  putAcceptTest,
  putRejectTest,
} from 'src/services/insightTestsServices';
import TestAccept from 'src/pages/InsigthFactory/TestAccept/TestAccept';
import { swalMessages, permitsList } from 'src/constants';
import swal from 'sweetalert';
import { getUnidades } from 'src/services/insightService';
import * as paths from '../../routes/paths';
import { Context } from '../../context/Contex';

const TestAcceptContainer = () => {
  const [testAccept, setTestAccept] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [openResult, setOpenResult] = useState(false);
  const [result, setResult] = useState({});

  const history = useHistory();
  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];

  const fetchList = async () => {
    const { success, data } = await fetchTestAccept();
    if (success) {
      setTestAccept(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onAcceptTest = async (rowData) => {
    swal(swalMessages.ACCEPT_CONFIRM).then(async (willConfirm) => {
      if (willConfirm) {
        const { success } = await putAcceptTest({
          tipo: 'aprobar',
          id: rowData.id,
        });
        if (success) {
          const updatedTestAccept = testAccept.filter(
            (test) => test.id !== rowData.id,
          );
          swal(swalMessages.SUCCESSFUL_APPROVAL);
          setTestAccept(updatedTestAccept);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const onRejectTest = async (rowData) => {
    swal(swalMessages.REJECT_CONFIRM).then(async (willConfirm) => {
      if (willConfirm) {
        const { success } = await putRejectTest({
          tipo: 'rechazar',
          id: rowData.id,
        });
        if (success) {
          const updatedTestAccept = testAccept.filter(
            (test) => test.id !== rowData.id,
          );
          swal(swalMessages.SUCCESFUL_REJECT);
          setTestAccept(updatedTestAccept);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const fetchUnidades = async () => {
    const { success, data } = await getUnidades();
    if (success) {
      setUnidades(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const withoutPermit = (permit) => {
    if (permit < 4) {
      history.push('/insight_factory');
    } else {
      return null;
    }
  };

  const onOpenView = (rowData) => {
    setResult(rowData);
    setOpenResult(true);
  };
  const onCloseView = () => {
    setOpenResult(false);
  };
  const openNewTab = (url) => {
    const win = window.open(url, '_blank');
    win.focus();
  };
  const fetchUrl = async (urlFirmada) => {
    openNewTab(urlFirmada);
  };

  const onClickReturn = () => {
    history.push(paths.INSIGHT_FACTORY);
  };

  useEffect(() => {
    withoutPermit(permitValue);
    fetchList();
    fetchUnidades();
  }, []);
  return (
    <TestAccept
      fetchUrl={fetchUrl}
      result={result}
      onOpenView={onOpenView}
      onCloseView={onCloseView}
      openResult={openResult}
      unidades={unidades}
      testAccept={testAccept}
      onAcceptTest={onAcceptTest}
      onRejectTest={onRejectTest}
      onClickReturn={onClickReturn}
    />
  );
};

export default TestAcceptContainer;
